module.exports = __webpack_public_path__ + "img/service1.f28fc074.png";